import { apiPatch } from '@/shared/utils/requestBuilder';

export type PapelAtribuivel =
  | 'ADMIN'
  | 'SECRETARIA'
  | 'ESCRITORIO_MEMBRO'
  | 'ADVOGADO'
  | 'ASSISTENTE'
  | 'ARBITRO';

export const usuarioPapelAdminService = {
  alterar: async (usuarioId: string, papel: PapelAtribuivel): Promise<PapelAtribuivel> => {
    const response = await apiPatch(`/admin/usuarios/${usuarioId}/papel`, { papel });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao alterar papel' }));
      throw new Error(errorData.error || 'Erro ao alterar papel do usuário');
    }
    const result = await response.json();
    return result.data.tipoUsuario as PapelAtribuivel;
  },
};
